module.exports = __webpack_public_path__ + "static/media/icn_mainnav_search_light.22e45db2.svg";